function isCCREnabled() {
    const { isCCRewardsEnabled } = Sephora.configurationSettings;

    return isCCRewardsEnabled;
}

export default isCCREnabled;
